import { ListGroup } from 'react-bootstrap';
import ChapterItem from './ChapterItem';
import DeleteChaptertModal from './DeleteChapterModal';
import ShareWordsModal from './ShareWordsModal';

import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import '../../styles/Chapters.css';
import { DndContext, PointerSensor, useSensor, useSensors, closestCorners, TouchSensor} from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove} from "@dnd-kit/sortable";

export default function ChaptersList({
     project,
    updateProject
}) {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(TouchSensor, {
        activationConstraint: {
        delay: 150,  // trzeba przytrzymać palec 150ms
        tolerance: 5,
        },
    })
    );

    const [editingIndex, setIndex] = useState(null);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [showDeleteModal, setshowDeleteModal] = useState(false);

    const [showShareModal, setShowShareModal] = useState(false);
    const [fromIndex, setFromIndex] = useState(null);
    const [toIndex, setToIndex] = useState(null);
    const [wordsToTransfer, setWordsToTransfer] = useState(0);


    const [deleteMode, setDeleteMode] = useState("delete"); 
    const [moveChapterIndex, setMoveChapterIndex] = useState(null);

    const [renameMode, setRenameMode] = useState("keep");
    
    if (!project || !project?.chapters) {
        return null;
    }

    const getTaskPos = (id) => project?.chapters.findIndex((chapter) => chapter.chapterID === id);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id === over.id) return;
    const originalPos = getTaskPos(active.id);
    const newPos = getTaskPos(over.id);
    const updatedChapters = arrayMove(project?.chapters, originalPos, newPos);
    updateProject({ ...project, chapters: updatedChapters });
  };


    const deleteChapter=()=>{
        let chapters = [...project?.chapters];
        let actualwords = project?.actualwords ?? 0;
        let removedwords = chapters[deleteIndex].words ?? 0;
        if(deleteMode === "move"){
            chapters[moveChapterIndex].words += chapters[deleteIndex].words;
        }
        if(deleteMode === "delete"){
            actualwords -= removedwords;
        }
        chapters.splice(deleteIndex, 1);
        if(renameMode === "change"){
            let chapterCounter = 1;
            chapters = chapters.map(ch => {
            if (ch.type === "chapter") {
                const newChapter = { ...ch, title: `Rozdział ${chapterCounter}` };
                chapterCounter++;
                return newChapter;
            }
            return ch;      
            });
        }
        updateProject({ ...project, actualwords, chapters});
        setDeleteIndex(null);
        setDeleteMode("delete");
        setMoveChapterIndex(null);
        setRenameMode("keep");
    }

    const transferWords=()=>{
         if (
            fromIndex == null ||
            toIndex == null ||
            wordsToTransfer <= 0
        ) return;
        let chapters = [...project?.chapters];
        chapters[fromIndex] = {
            ...chapters[fromIndex],
            words: chapters[fromIndex].words - wordsToTransfer
        }

         chapters[toIndex] = {
            ...chapters[toIndex],
            words: chapters[toIndex].words + wordsToTransfer
        }

        updateProject({ ...project, chapters});
        setShowShareModal(false);
        setToIndex(null);
        setFromIndex(null);
        setWordsToTransfer(0);

    }

    
    return (
    <div>
    <h4> Rozdziały </h4>
    <DndContext 
    sensors={sensors} 
    collisionDetection={closestCorners}
    onDragEnd={handleDragEnd}>
        <SortableContext items={project?.chapters.map(ch => ch.chapterID)} strategy={verticalListSortingStrategy} >
        
            {project?.chapters.map((chapter, i) => (
                <ChapterItem
                    chapter = {chapter}
                    editingIndex = {editingIndex}
                    setEditingIndex = {setIndex}
                    index = {i}
                    key = {chapter.chapterID}
                    onDelete = {() => {
                        setshowDeleteModal(true) 
                        setDeleteIndex(i)}}
                    onShare= {() => {
                        setShowShareModal(true)
                        setFromIndex(i)}}
                    minWords = {project?.settings.MinimumWordsInChapter}
                    setShowShareModal = {setShowShareModal}
                    project={project}
                    updateProject={updateProject}
                />
            ))}
        </SortableContext>
    </DndContext>

        {showDeleteModal && (
            <DeleteChaptertModal 
                onClose = {() => {
                    setshowDeleteModal(false);
                    setDeleteIndex(null);
                }}
                deleteChapter = {deleteChapter}
                show = {showDeleteModal}
                deleteMode = {deleteMode}
                setDeleteMode = {setDeleteMode}
                setMoveChapterIndex = {setMoveChapterIndex}
                deleteIndex = {deleteIndex}
                setRenameMode = {setRenameMode}
                renameMode = {renameMode}
                project = {project}
                
            />
        )}


        {showShareModal && (
        <ShareWordsModal
            show={showShareModal}
            onClose={()=> {
                setShowShareModal(false);
                setToIndex(null);
                setFromIndex(null);
                setWordsToTransfer(0);
            }}
            fromIndex = {fromIndex}
            project = {project}
            fromWords={project?.chapters[fromIndex].words ?? 0}
            toIndex={toIndex}
            setToIndex={setToIndex}
            wordsToTransfer={wordsToTransfer}
            setWordsToTransfer={setWordsToTransfer}
            toTransfer={transferWords}
        />
        )}

    </div>)
}